/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  INVESTMENTS_REPORT,
  INVESTMENT_APPLICATIONS,
  INVESTMENT_APPLICATION_DETAILS,
  INVESTMENT_PRODUCT_DETAIL,
  INVESTMENT_APPLICATION_STATEMENT,
  INVESTMENT_APPLICATION_STATEMENT_DETAILS,
} from '~/actions/actionTypes';

const initialState: reducers.InvestmentsReducer = {
  list: [],
  count: 0,
  detail: null,
  investmentApplications: [],
  investmentApplicationsStatement: null,
  investmentApplicationsStatementAccount: 0,
  investmentApplicationsStatementDetails: null,
  investmentApplicationDetails: {
    operationDate: '',
    productType: 0,
    paymentAccountId: '',
    coreId: '',
    grossAmount: 0,
    dueDate: '',
    flow: 0,
  },
};

const investmentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case INVESTMENTS_REPORT:
      state = {
        ...state,
        list: action.payload,
        count: action.payload.length,
      };
      break;
    case INVESTMENT_PRODUCT_DETAIL:
      state = {
        ...state,
        detail: action.payload,
      };
      break;

    case INVESTMENT_APPLICATIONS:
      state = {
        ...state,
        investmentApplications: action.payload,
      };

      break;
    case INVESTMENT_APPLICATION_DETAILS:
      state = {
        ...state,
        investmentApplicationDetails: action.payload,
      };

      break;

    case INVESTMENT_APPLICATION_STATEMENT:
      state = {
        ...state,
        investmentApplicationsStatement: action.payload,
        investmentApplicationsStatementAccount: action.payload.Titulos.length,
      };

      break;

    case INVESTMENT_APPLICATION_STATEMENT_DETAILS:
      state = {
        ...state,
        investmentApplicationsStatementDetails: action.payload,
      };

      break;

    default:
      return state;
  }

  return state;
};

export default investmentReducer;
